import(/* webpackMode: "eager", webpackExports: ["GenericEntityPageClient"] */ "/app/components/classrooms/generic-entity-page-client.tsx");
